module.exports = __webpack_public_path__ + "static/mstile-310x310-7e15c180f4352c77c3c229a5e964f6c7.png";